import pageImpl from "../../models/PageImpl";
import * as actionTypesNV05 from "./actionTypesNV05";

//
export const NV05ListeGetStart = () => {
  return { type: actionTypesNV05.NV05_LIST_GET_INIT };
};

//
export const NV05ListeGet = (listFormData: FormData = new FormData()) => {
  return { type: actionTypesNV05.NV05_LIST_GET, listFormData };
};

//
export const NV05ListeGetSuccess = (payload: pageImpl<any>) => {
  return { type: actionTypesNV05.NV05_LIST_GET_SUCCESS, payload };
};

//
export const NV05ListeGetFailed = (error: any) => {
  return { type: actionTypesNV05.NV05_LIST_GET_FAILED, error };
};

export const NV05ResetForm = (payload: any) => {
  return { type: actionTypesNV05.NV05_RESET_FORM, payload };
};

//  Set Reset state enabled
export const NV05SetResetFormEnabled = (payload: any) => {
  return { type: actionTypesNV05.NV05_SET_RESET_FORM_ENABLED, payload };
};

//  Reset form
export const NV05ClearComponentStore = () => {
  return { type: actionTypesNV05.NV05_RESET_COMPONENT_STORE };
};

export const setListFormData = (payload: any) => {
  return { type: actionTypesNV05.SET_LIST_FORMDATA, payload };
}

export const setSubFormData = (payload: any) => {
  return { type: actionTypesNV05.SET_SUB_FORMDATA, payload };
}

//  Update Column Header List
export const NV05UpdateColumnHeaderList = (list: TableHeaders[]) => {
  return { type: actionTypesNV05.NV05_SET_COLUMN_HEADER_LIST, list };
};
